import { Col, Form, Input, message, Modal, Row } from "antd";
import { Rule } from "antd/lib/form";
import { userPositionApi } from "api/userPosition.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { ModalStatus } from "types/modal";
import { UserPosition } from "types/user-position";

const rules: Rule[] = [{ required: true }];

export interface IPositionModal {
  handleCreate: () => void;
  handleUpdate: (Position: UserPosition) => void;
}

interface PositionForm extends UserPosition {
  positionAvatar: string;
}

export const PositionModal = ({
  visible,
  status,
  userPosition,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  userPosition: Partial<UserPosition>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<PositionForm>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (status == "create" && visible) {
      form.resetFields();
    }
    if (status == "update") {
      form.setFieldsValue({
        name: userPosition.name,
      });
    }
  }, [visible, status]);

  const createData = async () => {
    const valid = await form.validateFields();
    const data = { userPosition: form.getFieldsValue() };

    setLoading(true);
    try {
      const res = await userPositionApi.create(data);
      message.success("Thêm vị trí mới thành công!");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async () => {
    const valid = await form.validateFields();
    const data = { userPosition: form.getFieldsValue() };
    setLoading(true);
    try {
      const res = await userPositionApi.update(userPosition.id || 0, data);
      message.success("Cập nhật vị trí thành công!");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={status == "create" ? "Thêm vị trí" : "Cập nhật vị trí"}
      style={{ top: 20 }}
      width={700}
      confirmLoading={loading}
      onOk={() => {
        status == "create" ? createData() : updateData();
      }}
    >
      <Form layout="vertical" form={form}>
        <Row>
          <Col span={24}>
            <Form.Item label="Tên vị trí" name="name" rules={rules}>
              <Input placeholder="" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>)
  );
};
